import { render, staticRenderFns } from "./DiggingDialog.vue?vue&type=template&id=001ee247&scoped=true&"
import script from "./DiggingDialog.vue?vue&type=script&lang=ts&"
export * from "./DiggingDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001ee247",
  null
  
)

export default component.exports